import { render, staticRenderFns } from "./ChangeTypeDialog.vue?vue&type=template&id=59554222&scoped=true"
import script from "./ChangeTypeDialog.vue?vue&type=script&lang=js"
export * from "./ChangeTypeDialog.vue?vue&type=script&lang=js"
import style0 from "./ChangeTypeDialog.vue?vue&type=style&index=0&id=59554222&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59554222",
  null
  
)

export default component.exports